export const ANIMATION_TYPE = 'fromTo';
export const TIMELINE_ID = 'transition';
export enum TimelineLabel {
    START  = 'transition-start',
    COMPLETE = 'transition-complete',
}
